import { commaFormat } from "@p-ban/common/src/utils/NumberUtils"

type Props = {
  currency: number | null
  className?: string
  amountClassName?: string
}

const Currency = ({ currency, className, amountClassName }: Props) => {
  const cur = currency !== null ? commaFormat(currency) : "ー"

  return (
    <span className={className}>
      <span className={amountClassName}>{cur}</span>円
    </span>
  )
}

export default Currency
